// extracted by mini-css-extract-plugin
module.exports = {"SideBarMenu":"SideBarMenu_SideBarMenu__2dEuW","Open":"SideBarMenu_Open__2TbUv","Close":"SideBarMenu_Close__552_z"};